import mock from '../../MockConfig';
import healthCare from '../../db/dashboard/healthCare';



mock.onGet('/dashboard/health_care').reply(200, healthCare);
